import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProductZoom from "../../components/ProductZoom";
import { useLazyTransactionDetailsQuery } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const TransactionView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [details, setDetails] = useState({});
  const [transaction, settransaction] = useState({});
  const [booking, setbooking] = useState({});
  const [subscription, setsubscription] = useState({});
  const [recommendation, setrecommendation] = useState({});
  const [wallet, setwallet] = useState({});

  //RTK QUERY
  const [propertyViewApi] = useLazyTransactionDetailsQuery();

  // DETAILS VIEW
  const getView = () => {
    propertyViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        settransaction(res?.transaction);
        if (res?.transaction.type == "booking") {
          setbooking(res?.booking);
        }
        if (res?.transaction.type == "mcc") {
          setsubscription(res?.subscription);
        }
        if (res?.transaction.type == "recommendation") {
          setrecommendation(res?.recommendation);
        }
        if (res?.transaction.type == "wallet") {
          setwallet(res?.wallet);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"transaction-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="user-detail-table">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  Details
                </th>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>Property Name</td>
                  <td>:</td>
                  <td>
                    {booking?.property
                      ? booking?.property?.name
                      : recommendation?.property
                      ? recommendation?.property?.name
                      : wallet?.property
                      ? wallet?.property?.name
                      : subscription?.property
                      ? subscription?.property?.name
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Property Image</td>
                  <td>:</td>
                  <td>
                    {booking?.property ? (
                      <img
                        src={booking?.property?.image}
                        alt="property-img"
                        class="img-fluid"
                        style={{ width: "30%" }}
                      />
                    ) : recommendation?.property ? (
                      <img
                        src={recommendation?.property?.image}
                        alt="property-img"
                        class="img-fluid"
                        style={{ width: "30%" }}
                      />
                    ) : wallet?.property ? (
                      <img
                        src={wallet?.property?.image}
                        alt="property-img"
                        class="img-fluid"
                        style={{ width: "30%" }}
                      />
                    ) : subscription?.property ? (
                      <img
                        src={subscription?.property?.image}
                        alt="property-img"
                        class="img-fluid"
                        style={{ width: "30%" }}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Owner Name</td>
                  <td>:</td>
                  <td>
                    {transaction?.owner?.name ? transaction?.owner?.name : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Date</td>
                  <td>:</td>
                  <td>
                    {" "}
                    {transaction?.created_at
                      ? moment(transaction?.created_at).format(
                          "DD-MM-YYYY hh:mm a"
                        )
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Amount</td>
                  <td>:</td>
                  <td>₹{transaction?.transaction_amount}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Type</td>
                  <td>:</td>
                  <td>{transaction?.type}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Status</td>
                  <td>:</td>
                  <td>
                    {transaction?.status == 0
                      ? "Initiated"
                      : transaction?.status == 1
                      ? "Success"
                      : "Failure"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionView;
